/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';

export interface DeleteAdministrationOrganizationWebhook$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;

/**
 * The webhook key
 */
  webhookKey: KeyType;
}

export function deleteAdministrationOrganizationWebhook(http: HttpClient, rootUrl: string, params: DeleteAdministrationOrganizationWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteAdministrationOrganizationWebhook.PATH, 'delete');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.path('webhookKey', params.webhookKey, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteAdministrationOrganizationWebhook.PATH = '/administration/organizations/{organizationKey}/webhooks/{webhookKey}';
